import { getApps, initializeApp } from 'firebase/app';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const config = {
  apiKey: publicRuntimeConfig.firebaseApiKey,
  authDomain: publicRuntimeConfig.firebaseAuthDomain,
  databaseURL: publicRuntimeConfig.firebaseDatabaseUrl,
  projectId: publicRuntimeConfig.firebaseProjectId,
  storageBucket: publicRuntimeConfig.firebaseStorageBucket,
  messagingSenderId: publicRuntimeConfig.firebaseMessagingSenderId,
  appId: publicRuntimeConfig.firebaseAppId,
};

export default !getApps().length ? initializeApp(config) : undefined;
